<template>
  <div class="accont">
    <div class="container mt-5 mb-5">
      <div class="row accont-title mb-2">Configuración de cuenta</div>
      <AccontInfo />
      <BankInfo />
      <ChangePassword />
    </div>
  </div>
</template>

<script>
import ChangePassword from '@/components/accont/ChangePassword.vue'
import AccontInfo from '@/components/accont/AccontInfo.vue'
import BankInfo from '@/components/accont/BankInfo.vue'

export default {
  components: {
    ChangePassword,
    AccontInfo,
    BankInfo
  }
}
</script>
